import * as React from 'react';
import {AppBar, Toolbar, Typography, Box, Menu, MenuItem, Divider, useMediaQuery} from '@mui/material';
import {Link, useNavigate} from "react-router-dom";

import AppLogo from '../../../../assets/images/onboardPage/hypercept_logo.png'
import AvatarLogo from '../../../../assets/images/svgs/avatar.svg'
import HamburgerIcon from '../../../../assets/images/svgs/hamburger.svg';

import {useAppContext, useSnackbar} from "../../../../contexts";
import {contactFaqUrl} from '../../../../constants';
import {theme} from '../../../../utils';
import {mobileStyles, styles} from './header-helpers';
import {LogoutDialogBox} from "../logoutDialog/LogoutDialog";
import {useIsNavActive} from '../../../../hooks';
import {DesktopNav} from "./DesktopNav";
import {ProfileMenu} from "./ProfileMenu";


export const Header = () => {
    const navigate = useNavigate()
    const homeActive = useIsNavActive("/home");
    const educationActive = useIsNavActive("/education-hub");
    const aiToolsActive = useIsNavActive("/ai-tools");

    const {userData} = useAppContext()
    const {showSnackbar} = useSnackbar();
    const isMobile = useMediaQuery(theme.breakpoints.down(950))

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [openDialog, setOpenDialog] = React.useState<boolean>(false)
    const [anchorNavEl, setAnchorNavEl] = React.useState<null | HTMLElement>(null);

    const openMenu = Boolean(anchorEl);
    const openNavMenu = Boolean(anchorNavEl);

    const firstName = userData?.firstName ?? ""
    const lastName = userData?.lastName ?? ""
    const fullName = firstName + ' ' + lastName
    const mailId = userData?.emails?.find((mail: any) => mail?.isPrimary)?.email

    const profileName = fullName || mailId;
    const specialtyName = userData?.specialties?.find((val: any) => val?.type)?.name || ""
    const isDesktop = !isMobile;

    const onCloseNavMenu = () => {
        setAnchorNavEl(null);
    };

    const onCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleLogoutMenu = () => {
        setAnchorEl(null);
        setOpenDialog((prev: boolean) => !prev);
    }

    const onClickFaq = () => {
        if (contactFaqUrl) {
            window.open(contactFaqUrl, '_blank', 'noopener,noreferrer');
        } else {
            showSnackbar("link is not available!", "error")
        }
    }

    return (
        <AppBar position='fixed' color="inherit" sx={styles.headerWrapper}>
            <Toolbar sx={styles.mainToolbar}>
                <Box sx={styles.appLogo}>
                    {isMobile ?
                        // Mobile HamburgerIcon
                        <Box onClick={(event) => setAnchorNavEl(event.currentTarget)}>
                            <img src={HamburgerIcon} alt="hamburger-icon"
                                 style={mobileStyles.hamburgerIcon}/>
                        </Box>
                        : null}

                    {/* App Logo */}
                    <Link to={"/home"}>
                        <img src={AppLogo}
                             style={{height: isMobile ? "25px" : "49px", width: "*"}}
                             alt='astellas-layout-logo'/>
                    </Link>
                </Box>
                {isDesktop && <DesktopNav />}

                {/* open profile menu button, and name/specialty for desktop */}
                <Box sx={styles.profile.container} onClick={handleClick}>
                    <Box sx={styles.profile.avatarContainer}>
                        <img src={AvatarLogo} style={styles.profile.avatarImage} alt='avatar-logo'/>
                    </Box>
                    {isDesktop && (
                        <Box sx={styles.profile.userNameWrapper}>
                            <Typography sx={styles.profile.username}>{profileName}</Typography>
                            <Typography sx={styles.profile.specialtyName}>{specialtyName}</Typography>
                        </Box>
                    )}
                </Box>

                {/* Mobile Navigation Menu */}
                <Menu
                    anchorEl={anchorNavEl}
                    id="account-menu"
                    open={openNavMenu}
                    onClose={onCloseNavMenu}
                    onClick={onCloseNavMenu}
                    slotProps={{
                        paper: {
                            elevation: 0,
                            sx: {
                                overflow: 'visible',
                                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                width: 280,
                                px: "10px",
                                py: "12px",
                                borderRadius: "8px",
                                mt: "8.5px"
                            },
                        },
                    }}
                    transformOrigin={{horizontal: 'left', vertical: 'top'}}
                    anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}>
                    <MenuItem sx={[styles.subHeaderText, {mb: "0px"}]} selected={homeActive}
                              onClick={() => navigate("/home")}>
                        Home
                    </MenuItem>
                    <Divider/>
                    <MenuItem sx={[styles.subHeaderText, {mb: "0px"}]} selected={educationActive}
                              onClick={() => navigate("/education-hub")}>
                        Education Hub
                    </MenuItem>
                    <MenuItem sx={[styles.subHeaderText, {mb: "0px"}]} selected={aiToolsActive}
                              onClick={() => navigate("/ai-tools")}>
                        AI Tools
                    </MenuItem>
                </Menu>

                {/* Profile Menu */}
                <ProfileMenu
                    anchorEl={anchorEl}
                    openMenu={openMenu}
                    onCloseMenu={onCloseMenu}

                    handleLogoutMenu={handleLogoutMenu}
                    onClickFaq={onClickFaq}
                />

                <LogoutDialogBox showDialog={openDialog} onCloseLogout={() => setOpenDialog(false)}/>
            </Toolbar>
        </AppBar>
    );
};
